import SingleChallengePage from "./SingleChallengePage";

export const SingleChallengePageRenderLogic = () => {
  // Default layout
  return <SingleChallengePage />;
};
